"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MappingMain = void 0;
var react_1 = __importDefault(require("react"));
var immutable_1 = require("immutable");
var structure_1 = require("remota-client/component/structure");
var button_1 = require("remota-client/component/button");
var line_1 = require("./line");
var labels_1 = require("../labels");
var MappingMain = function (props) {
    var mapping = props.mapping, useUpdateExternalMappings = props.useUpdateExternalMappings, fields = props.fields;
    var _a = __read(react_1.default.useState(mapping), 2), state = _a[0], setState = _a[1];
    var _b = __read(useUpdateExternalMappings(), 1), update = _b[0];
    var handleChange = react_1.default.useCallback(function (index) { return function (column) {
        setState((0, immutable_1.setIn)(state, ["columns", index], column));
    }; }, [state, setState]);
    var handleDelete = react_1.default.useCallback(function (index) { return function () {
        setState(__assign(__assign({}, state), { columns: state.columns.filter(function (_, i) { return i !== index; }) }));
    }; }, [state, setState]);
    var handleAdd = react_1.default.useCallback(function () {
        var order = Math.max.apply(Math, __spreadArray([-1], __read(state.columns.map(function (c) { return c.order; })), false)) + 1;
        setState(__assign(__assign({}, state), { columns: state.columns.concat({ order: order, remotaKey: "", remotaValue: "", externalKey: "", externalValue: "" }) }));
    }, [state, setState]);
    var isValid = state.columns.every(function (c) { return c.remotaKey !== "" && c.externalKey !== ""; });
    var handleSave = react_1.default.useCallback(function () {
        update(state);
    }, [state, update]);
    var customListFields = react_1.default.useMemo(function () { return fields.filter(function (field) { return field.isCustomField; }); }, [fields]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(structure_1.FormGroupStructure, { label: "".concat(labels_1.labels.system[mapping.system], " - ").concat(labels_1.labels.masterType[mapping.masterType]), fullwidth: true },
            state.columns.map(function (column, index) {
                return (react_1.default.createElement(line_1.Line, { key: column.order, column: column, onChange: handleChange(index), onDelete: handleDelete(index), fields: customListFields, lists: props.lists }));
            }),
            react_1.default.createElement(structure_1.FormLineStructure, null,
                react_1.default.createElement(button_1.NormalButton, { onClick: handleAdd }, "\u8FFD\u52A0"))),
        react_1.default.createElement(structure_1.FormGroupStructure, { label: "" },
            react_1.default.createElement(button_1.AccentButton, { "data-testid": "ExternalMappingCustomListConcurEdit_Submit", thin: true, onClick: handleSave, disabled: !isValid }, "\u66F4\u65B0"))));
};
exports.MappingMain = MappingMain;
